import React from 'react';
import Summary from "./Summary";
import ComparisonResult from "./ComparisonResult";

export const Report = () => <>
  <Summary/>
  <ComparisonResult/>
</>;
